import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { CHART_NO_DATA_ICON } from '../../Assets'

const ChartNoDataStyled = styled.div`
  width: 100%;
  background: rgba(196, 196, 196, 0.02);
  border: 4px solid #D6D6D6;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

  display: flex;
  align-items: center;
  justify-content: space-around;
  
  padding: 42px 0 28px;
  margin-bottom: 28px;
  
  p {
    &:first-child {
      font-weight: 700;
      font-size: 18px;
      line-height: 20px;

      color: #000000;
    }
    
    &:last-child {
      font-weight: 400;
      font-size: 18px;
      line-height: 20px;

      color: #000000;
    }
  }
`

const ChartNoData = () => {
  const { t } = useTranslation()
  return (
    <ChartNoDataStyled>
      <CHART_NO_DATA_ICON />

      <div className="content">
        <p>{t('no_data')}</p>
        <p>{t('input_diagram_please')}</p>
      </div>
    </ChartNoDataStyled>
  )
}

export default ChartNoData
